module.exports = __webpack_public_path__ + "static/media/unscript.8d2f7791.jpeg";